{
  "toast": {
    "automationCreated": "Automation créé",
    "actionAdded": "Action ajoutered",
    "boardCreated": "Board créé",
    "dependencyAdded": "Dependency ajoutered",
    "issueCreated": "Issue créé",
    "projectArchived": "Project archived",
    "projectCloned": "Project cloned",
    "projectCreated": "Project créé",
    "ifRegisteredALoginLinkWasSentTo": "If registered, a login link was sent à votre email",
    "signedIn": "Signed in",
    "portfolioCreated": "Portfolio créé",
    "resourceAllocated": "Resource allocated",
    "documentUploaded": "Document uploaded",
    "projectCreatedFromTemplate": "Project créé de template",
    "clientPortalUserCreated": "Client portal user créé",
    "sprintStarted": "Sprint started",
    "sprintCompleted": "Sprint terminé",
    "taskAddedToSprint": "Task ajoutered à sprint",
    "taskUpdated": "Task mis à jour",
    "taskCreated": "Task créé",
    "taskDeleted": "Task deleted",
    "timeLogged": "Time logged",
    "timesheetSubmitted": "Timesheet soumis",
    "reportExported": "{{reportType}} exporté",
    "financeInvoiceCreated": "Facture finance {{invoiceNumber}} créée ({{lineCount}} lignes)",
    "tasksSynced": "{{count}} tâches synchronisées vers le tableau"
  },
  "errors": {
    "failedToLoadAutomations": "Échec du chargement de automations",
    "failedToLoadActions": "Échec du chargement de actions",
    "createFailed": "Échec de la création",
    "addActionFailed": "Échec de add action",
    "failedToLoadBoards": "Échec du chargement de boards",
    "failedToLoadBoard": "Échec du chargement de board",
    "createBoardFailed": "Échec de create board",
    "syncFailed": "Échec de la synchronisation",
    "moveFailed": "Échec du déplacement",
    "failedToLoadCalendar": "Échec du chargement de calendar",
    "enterBothTaskIds": "Saisissez both task IDs",
    "failedToLoadGantt": "Échec du chargement de gantt",
    "addDependencyFailed": "Échec de add dependency",
    "archiveFailed": "Échec de archive",
    "cloneFailed": "Échec du clonage",
    "requestFailed": "Échec de la requête",
    "verificationFailed": "Échec de la vérification",
    "budgetLoadFailed": "Échec de budget load",
    "reportsUnavailable": "Rapports unavailable",
    "exportFailed": "Échec de l'export",
    "failedToLoadResources": "Échec du chargement de resources",
    "allocateFailed": "Échec de allocate",
    "failedToLoadTemplates": "Échec du chargement de templates",
    "uploadFailed": "Échec du téléversement",
    "instantiateFailed": "Échec de instantiate",
    "portalInviteFailed": "Échec de portal invite",
    "backlogLoadFailed": "Échec de backlog load",
    "startSprintFailed": "Échec de start sprint",
    "completeSprintFailed": "Échec de complete sprint",
    "assignFailed": "Échec de l'assignation",
    "selectAProject": "Sélectionnez un project",
    "deleteFailed": "Échec de la suppression",
    "enterBillingDateRange": "Saisissez billing date range",
    "logTimeFailed": "Échec de log time",
    "billTimeFailedEnsureFinanceModuleAndBillable": "Bill time failed — ensure Finance module et billable hours exist",
    "submitFailed": "Échec de la soumission",
    "analyticsUnavailable": "Analytics unavailable",
    "failedToLoadIssues": "Échec du chargement de issues",
    "failedToLoadProjects": "Échec du chargement de projects",
    "failedToLoadPortfolios": "Échec du chargement de portfolios",
    "failedToLoadSprints": "Échec du chargement de sprints",
    "failedToLoadTasks": "Échec du chargement de tasks",
    "failedToLoadTimesheets": "Échec du chargement de timesheets"
  },
  "pages": {
    "automation": "Automation",
    "createAutomation": "Create automation",
    "addWorkflowAction": "Add flux de travail action",
    "workflowTriggersAndActionsForTasks": "Flux de travail triggers et actions pour tasks et sprints",
    "boards": "Boards",
    "createBoard": "Create board",
    "kanbanBoardsWithDragAndDrop": "Kanban boards avec drag-and-drop, WIP limits, et flux de travail columns",
    "calendar": "Calendar",
    "milestonesAndTaskDueDates": "Milestones et task due dates",
    "projectsDashboard": "Projects Tableau de bord",
    "deliveryDetails": "Delivery details",
    "tasks": "Tasks",
    "issues": "Issues",
    "activeSprints": "Active Sprints",
    "deliveryHealthAcrossProjectsTasksIssues": "Delivery health across projects, tasks, issues, et sprints in votre scope",
    "gantt": "Gantt",
    "timelineViewWithDependenciesAndCritical": "Timeline afficher avec dependencies et critical path",
    "createIssue": "Create issue",
    "bugsAndDeskTicketEscalationsAuto": "Bugs et Desk ticket escalations (auto-linked de Desk)",
    "projects": "Projects",
    "createProject": "Create project",
    "portfolioOfClientAndInternalDelivery": "Portfolio of client et internal delivery projects",
    "projectClientPortal": "Project client portal",
    "verifyLogin": "Verify login",
    "viewYourProjectStatusTasksDocuments": "View votre project status, tasks, documents, et factures",
    "completeClientPortalSignIn": "Complete client portal sign-in",
    "pmoPortfolio": "PMO & Portfolio",
    "createPortfolio": "Create portfolio",
    "executiveDashboardPortfoliosAndProjectBudget": "Executive tableau de bord, portfolios, et project budget health",
    "projectReports": "Project Rapports",
    "deliveryAnalyticsAndExportableReports": "Delivery analytics et exportable rapports",
    "resourcePlanning": "Resource planning",
    "teamAllocationAndCapacityByProject": "Team allocation et capacity by project",
    "projectSetup": "Project Setup",
    "templatesClientPortalAndConfiguration": "Templates, client portal, et configuration",
    "pdfWordExcelOrImages": "PDF, Word, Excel, ou images",
    "sprints": "Sprints",
    "startSprint": "Start sprint",
    "backlogSprintPlanningExecutionAndVelocity": "Backlog, sprint planning, execution, et velocity",
    "edit": "Modifier",
    "delete": "Supprimer",
    "hierarchicalTasksWithCreateEditAnd": "Hierarchical tasks avec create, edit, et delete",
    "timesheets": "Timesheets",
    "logTime": "Log time",
    "submitTimesheet": "Submit timesheet",
    "logTimeSubmitWeeklyTimesheetsAnd": "Log time, submit weekly timesheets, et approve hours",
    "workload": "Workload",
    "activeProjects": "Active projects",
    "taskCompletion": "Task completion",
    "loggedHoursMonth": "Logged hours (month)",
    "sprintVelocity": "Sprint velocity",
    "resourceUtilizationAndCapacityPlanning": "Resource utilization et capacity planning"
  },
  "labels": {
    "ruleName": "Rule name",
    "triggerEvent": "Trigger event",
    "actionType": "Action type",
    "boardCode": "Board code",
    "boardName": "Board name",
    "selectProject": "Select project",
    "taskId": "Task ID",
    "dependsOnTaskId": "Depends on task ID",
    "title": "Title",
    "description": "Description",
    "projectCode": "Project code",
    "projectName": "Project name",
    "budget": "Budget",
    "organizationId": "Organization ID",
    "email": "Email",
    "token": "Token",
    "code": "Code",
    "name": "Nom",
    "allocation": "Allocation %",
    "clientEmail": "Client email",
    "uploadDocument": "Upload document",
    "sprintCode": "Sprint code",
    "sprintName": "Sprint name",
    "goal": "Goal",
    "backlogProject": "Backlog project",
    "allProjects": "All projects",
    "project": "Project",
    "date": "Date",
    "hours": "Hours"
  },
  "formActions": {
    "submitWeek": "Soumettre la semaine"
  },
  "listActions": {
    "newProject": "Nouveau projet",
    "newBoard": "Nouveau tableau",
    "syncTasks": "Synchroniser les tâches",
    "newPortfolio": "Nouveau portefeuille",
    "newTask": "Nouvelle tâche",
    "newIssue": "Nouveau ticket",
    "newRule": "Nouvelle règle",
    "logTime": "Saisir le temps",
    "startSprint": "Démarrer le sprint",
    "start": "Démarrer",
    "useTemplate": "Utiliser",
    "grantPortalAccess": "Accorder l'accès au portail",
    "sendMagicLink": "Envoyer le lien magique"
  }
}
